// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	GoBackToIntegrationPageButton: 'go-back-to-integration-page-button',
} as const;
